import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/bancos/bancos';
import BancosForm from './Bancos';


const ms2p = (state) => {
  return {
    ...state.bancos,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(BancosForm);
